// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"8b37b73e","470":"5063a374","496":"95c38a50","733":"ffe581b9"}[chunkId] + ".chunk.js";
};